import type { PortalDraftListItem } from '../../modules/drafts/model/drafts';

// Presentation only; identity, order and pagination remain owned by the server.
export function draftModel(draft: PortalDraftListItem) {
  return { ...draft, title: draft.processName || draft.title };
}
